import Seo from "@/components/layout/Seo";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFoundPage() {
    return (
        <>
            <Seo title="Page introuvable" description="La page recherchée n’existe pas ou plus." noindex={true} />
            <section className="bg-white">
                <div className="rcps-container py-28 md:py-40 max-w-2xl">
                    <p className="kicker text-navy-700"><span className="hairline" /> Erreur 404</p>
                    <h1 className="mt-4 font-heading text-4xl md:text-6xl font-semibold text-navy-700 leading-tight tracking-tight">
                        Cette page n’existe pas.
                    </h1>
                    <p className="mt-6 text-navy-700/70 leading-relaxed">
                        La page recherchée a peut-être été déplacée ou n’existe plus. Retournez à l’accueil ou
                        contactez-nous pour toute question.
                    </p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        <Link to="/" className="inline-flex items-center gap-2 h-12 px-6 rounded-md bg-navy-700 text-white font-semibold hover:bg-navy-800 transition">
                            Retour à l’accueil <ArrowRight className="w-4 h-4" />
                        </Link>
                        <Link to="/contact" className="inline-flex items-center gap-2 h-12 px-6 rounded-md border border-concrete-200 text-navy-700 font-semibold hover:bg-concrete-100 transition">
                            Contact
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}
